const AUTH_ENTRY_PATHS = new Set([
  "/login",
  "/register",
  "/signup",
  "/email-verification",
  "/set-password",
]);

const INTERNAL_URL_BASE = "https://app.seexr.dev";

/**
 * 로그인 완료 후 이동할 수 있는 앱 내부 경로만 반환한다.
 * 외부 URL과 인증 페이지로의 순환 이동은 홈으로 정규화한다.
 */
export function safeAuthReturnPath(value: string | null | undefined): string {
  if (!value || !value.startsWith("/") || value.startsWith("//")) return "/";

  try {
    const url = new URL(value, INTERNAL_URL_BASE);
    if (url.origin !== INTERNAL_URL_BASE || AUTH_ENTRY_PATHS.has(url.pathname)) {
      return "/";
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return "/";
  }
}

export function buildLoginHref(returnPath: string): string {
  const params = new URLSearchParams({
    redirect: safeAuthReturnPath(returnPath),
  });
  return `/login?${params.toString()}`;
}

/** 기존 q 기반 미전송 메시지 복원 링크도 redirect와 함께 지원한다. */
export function resolveAuthReturnPath(searchParams: URLSearchParams): string {
  const redirect = searchParams.get("redirect");
  if (redirect !== null) return safeAuthReturnPath(redirect);

  const query = searchParams.get("q");
  if (query) return `/?${new URLSearchParams({ q: query }).toString()}`;
  return "/";
}

/** 인증 흐름의 다음 페이지로 이동할 때 원래 복귀 주소를 전달한다. */
export function withAuthReturnPath(path: string, returnPath: string): string {
  const url = new URL(path, INTERNAL_URL_BASE);
  url.searchParams.set("redirect", safeAuthReturnPath(returnPath));
  return `${url.pathname}${url.search}${url.hash}`;
}
